import { Loader } from '@bordrio/ui-components';
import Alert from '../Alert';

interface Props {
  className?: string;
  error?: Error | string | null;
}

function getErrorString(error: Error | string): string {
  if (error instanceof Error) {
    return 'Sorry, we could not load the data.';
  }
  return error;
}

function ErrorableLoader({ className, error }: Props): JSX.Element {
  if (!error) {
    return <Loader className={className} />;
  }
  return (
    <Alert type="error" className={className}>
      {getErrorString(error)}
    </Alert>
  );
}

export default ErrorableLoader;
